<template>
  <a-spin :spinning="loading">
    <div style="max-width: 700px">
      <a-form layout="vertical">
        <a-form-item>
          <a-switch v-model="form.enabled" />
          <span class="ml-2">{{ $t("pickup.enabled") }}</span>
        </a-form-item>

        <a-form-item :label="$t('pickup.radius')">
          <a-input-number
            v-model="form.radiusMeters"
            style="width: 100%"
            :min="10"
            :max="5000"
            :step="50"
          />
        </a-form-item>

        <h6 class="mt-3">{{ $t("pickup.location") }}</h6>
        <a-alert
          class="mb-3"
          type="info"
          show-icon
          :message="locationHint"
        />
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.geoLat')">
              <a-input-number
                v-model="form.lat"
                style="width: 100%"
                :min="-90"
                :max="90"
                :step="0.000001"
                :placeholder="buildingLocation ? String(buildingLocation.lat) : ''"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.geoLng')">
              <a-input-number
                v-model="form.lng"
                style="width: 100%"
                :min="-180"
                :max="180"
                :step="0.000001"
                :placeholder="buildingLocation ? String(buildingLocation.lng) : ''"
              />
            </a-form-item>
          </div>
        </div>

        <a-alert
          v-if="form.enabled && !hasAnyLocation"
          class="mb-3"
          type="warning"
          show-icon
          :message="$t('pickup.noLocation')"
        />

        <a-button
          type="primary"
          :loading="saving"
          :disabled="form.enabled && !hasAnyLocation"
          @click="save"
        >
          {{ $t("action.enregistrer") }}
        </a-button>
      </a-form>
    </div>
  </a-spin>
</template>

<script>
import apiClient from '@/services/axios'
import { showApiError } from '@/utilities/showApiError'

function isSet(value) {
  return value !== null && value !== undefined && value !== ''
}

export default {
  name: 'pickupSettings',
  data() {
    return {
      loading: false,
      saving: false,
      buildingLocation: null,
      form: {
        enabled: false,
        radiusMeters: 1000,
        lat: null,
        lng: null,
      },
    }
  },
  computed: {
    hasPickupLocation() {
      return isSet(this.form.lat) && isSet(this.form.lng)
    },
    hasAnyLocation() {
      return this.hasPickupLocation || Boolean(this.buildingLocation)
    },
    locationHint() {
      return this.buildingLocation
        ? this.$t('pickup.locationHint')
        : this.$t('pickup.noBuildingLocation')
    },
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const { data } = await apiClient.get('/pickup/config')
        this.buildingLocation = data.buildingLocation
        this.form = {
          enabled: data.enabled,
          radiusMeters: data.radiusMeters,
          lat: data.pickupLocation ? data.pickupLocation.lat : null,
          lng: data.pickupLocation ? data.pickupLocation.lng : null,
        }
      } catch (err) {
        showApiError(this, err)
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (isSet(this.form.lat) !== isSet(this.form.lng)) {
        this.$message.warning(this.$t('pickup.latLngTogether'))
        return
      }
      this.saving = true
      try {
        await apiClient.put('/pickup/config', {
          enabled: this.form.enabled,
          radiusMeters: this.form.radiusMeters,
          lat: this.hasPickupLocation ? this.form.lat : null,
          lng: this.hasPickupLocation ? this.form.lng : null,
        })
        this.$message.success(this.$t('pickup.saved'))
      } catch (err) {
        showApiError(this, err)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
